import { useRef } from 'react'

import useClickOut from '../../../../hooks/useClickOut'
import styles from './Single.module.scss'

const Option = ({ handleClick, val, isActive, text }) => (
  <div
    onClick={() => handleClick(val)}
    className={isActive ? styles.optionActive : styles.option}
  >
    {text}
  </div>
)

const SingleSelect = ({ options, selectedOption, handleChange, handleClose }) => {
  const node = useRef()
  useClickOut(node, handleClose)

  return (
    <div ref={node} className={styles.sortDropdown}>
      {Object.keys(options).map(k => (
        <Option
          handleClick={handleChange}
          val={k}
          isActive={k === selectedOption}
          key={k}
          text={options[k]}
        />
      ))}
    </div>
  )
}

export default SingleSelect
